<template>
  <a-layout-header class="com-nav-header" :style="{ backgroundColor: navColor }">
    <div class="container fs">
      <!-- logo -->
      <img :src="logoUrl" :class="['logo', locale]">
      <!-- menu list -->
      <div class="menu-list">
        <a-menu
          popupClassName="nav-menu"
          v-model:selectedKeys="current"
          mode="horizontal"
          :items="items"
          @select="onSelect" />
      </div>
      <!-- language -->
      <a-dropdown
        placement="bottomLeft"
        :getPopupContainer="popupContainer"
        :class="['language-select', locale]"
        :trigger="['click']"
        overlayClassName="laguage-dropMenu"
      >
        <a-button class="fc">
          <img :src="languageIco">
          <span class="current_text">{{ currentLanguage[0] === 'cn' ? '中文' :'Eng' }}</span>
          <CaretDownOutlined />
        </a-button>
        <template #overlay>
          <a-menu v-model:selectedKeys="currentLanguage" @click="languageSelect">
            <a-menu-item :key="'cn'">简体中文</a-menu-item>
            <a-menu-item :key="'en'">English</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </a-layout-header>
</template>

<script setup>
import { h, ref, onMounted } from 'vue';
import { DownOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import { routes } from '@/router';
import { useI18n } from "vue-i18n";
const { locale } = useI18n({useScope: "global"})

const router = useRouter()
const navColor = ref('');
const current = ref(['mail']);
const logoUrl = require('@assets/images/logo.png')
const languageIco = require('@assets/icons/ico-language.svg')
const currentLanguage= ref([localStorage.getItem('language')]);
const navRouters = routes.map((i) => {
  let obj = {
    key: i.name,
    label: i?.meta?.title || '',
    title: i?.meta?.title || ''
  }
  if (i.children && !i?.meta?.hidden) {
    const children = i?.children.filter(citem => !citem?.meta?.hidden)
    obj.children = children?.map(k => {
      return {
        label: k?.meta?.title || '',
        key: k.name,
      }
    });
  }
  if (obj.children && obj.children.length) {
    obj.icon = () => h(DownOutlined);
  } else {
    delete obj.children;
  }
  return obj;
})

const items = ref(navRouters);
onMounted(() => {
  const route = useRoute();
  setTimeout(() => {
    if (route?.meta?.navColor) {
      navColor.value = route.meta.navColor;
    }
  }, 100)
})

const onSelect = ({ key }) => {
  router.push({
    name: key
  })
}

const popupContainer = () => document.querySelector('.com-nav-header')
const languageSelect = ({ key }) => {
  currentLanguage.value = [key];
  localStorage.setItem('language', key);
  locale.value = key;
  location.reload();
}
</script>

<style lang="less" scoped>
  .com-nav-header {
    background: rgba(32, 47, 49, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;

    .container {
      height: 60px;
      .logo {
        width: 76px;
        height: auto;
        margin-right: 158px;
        &.en {
          margin-right: 30px;
        }
      }

      .menu-list {
        /deep/ .ant-menu-item-group-title {
          display: none;
        }
        .ant-menu {
          background: transparent;
          flex: 1;
          /deep/ .ant-menu-item, /deep/ .ant-menu-submenu {
            &:after {
              display: none;
            }
          }
          /deep/ .ant-menu-item, /deep/ .ant-menu-submenu-title  {
            display: flex;
            flex-direction: row-reverse;

            .ant-menu-item-icon {
              color: #fff;
              svg {
                width: 12px;
                height: 12px;
              }
            }
            .ant-menu-title-content {
              color: #fff;
              margin-left: 0;
              margin-right: 5px;
            }
          }
          
        }
      }

      .language-select {
        width: 77px;
        height: 34px;
        margin-left: 163px;
        border: none;
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        border-radius: 6px;
        background: #3D464A;
        &.en {
          margin-left: 40px;
        }
        .current_text {
          margin: 0 5px;
        }
        .anticon {
          margin-left: 0;
        }

      }
    }
    /deep/ .laguage-dropMenu {
      top: 65px!important;
      .ant-dropdown-menu {
        width: 130px!important;
        padding: 15px 12px;
        border-radius: 6px;
        li {
          text-align: left;
          padding: 0 0;
          color: #3E4148;
          font-size: 12px;
          background-color: transparent;
          ~ li {
            margin-top: 12px;
          }
          &.ant-dropdown-menu-item-selected {
            color: #3071FF;
            &:after {
              content: '';
              width: 16px;
              height: 16px;
              display: inline-block;
              background: url('../../assets/icons/ico-language-selected.svg');
            }
          }
        }
      }
    }
  }
</style>